import { createAction } from "@reduxjs/toolkit";

import { IStartedBackgroundOperation } from "../types";

export const backgroundOperationStarted =
  createAction<IStartedBackgroundOperation>("background_operations/started");
